import Lookup from 'src/componentes/select2';
import Edit from '../paginas/tag/Edit';

const TagLookup = ({ podeEditar, showConditional, ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/TagLookup"
    editComponent={podeEditar ? Edit : null}
    clearable={true}
    selectNewItem={false}
    showConditional={showConditional}
    {...rest}
  />
);

export default TagLookup;
